import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getMetaForPath, siteUrl } from "../data/siteMeta";

function setMeta(selector, attribute, value) {
  if (!value) return;

  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement("meta");
    const match = selector.match(/\[(name|property)="([^"]+)"\]/);
    if (match) element.setAttribute(match[1], match[2]);
    document.head.appendChild(element);
  }

  element.setAttribute(attribute, value);
}

function setCanonical(href) {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}

function setStructuredData(meta, canonical, imageUrl) {
  const id = "vip-groups-structured-data";
  let script = document.getElementById(id);
  if (!script) {
    script = document.createElement("script");
    script.id = id;
    script.type = "application/ld+json";
    document.head.appendChild(script);
  }

  const structuredData = {
    "@context": "https://schema.org",
    "@type": meta.schemaType || "LocalBusiness",
    name: meta.businessName || "VIP Groups India",
    url: canonical,
    logo: `${siteUrl}/logo.png`,
    image: imageUrl,
    description: meta.description,
    areaServed: {
      "@type": "AdministrativeArea",
      name: "Tamil Nadu",
    },
    address: {
      "@type": "PostalAddress",
      streetAddress: "65, VIP Building, New West St, Udaiyargudi",
      addressLocality: "Kattumannarkoil",
      addressRegion: "Tamil Nadu",
      postalCode: "608301",
      addressCountry: "IN",
    },
    telephone: meta.telephone || "+91 9600557557",
    parentOrganization:
      meta.businessName && meta.businessName !== "VIP Groups India"
        ? {
            "@type": "Organization",
            name: "VIP Groups India",
            url: siteUrl,
          }
        : undefined,
    knowsAbout: Array.isArray(meta.keywords) ? meta.keywords : undefined,
  };

  script.textContent = JSON.stringify(structuredData);
}

function SEO() {
  const location = useLocation();

  useEffect(() => {
    const meta = getMetaForPath(location.pathname);
    const canonicalPath = meta.canonicalPath || location.pathname || "/";
    const canonical = `${siteUrl}${canonicalPath}`;
    const imageUrl = meta.image?.startsWith("http") ? meta.image : `${siteUrl}${meta.image}`;
    const keywords = Array.isArray(meta.keywords) ? meta.keywords.join(", ") : meta.keywords;

    document.title = meta.title;
    setMeta('meta[name="description"]', "content", meta.description);
    setMeta('meta[name="keywords"]', "content", keywords);
    setMeta('meta[name="robots"]', "content", "index, follow");
    setMeta('meta[property="og:title"]', "content", meta.title);
    setMeta('meta[property="og:description"]', "content", meta.description);
    setMeta('meta[property="og:type"]', "content", "website");
    setMeta('meta[property="og:url"]', "content", canonical);
    setMeta('meta[property="og:image"]', "content", imageUrl);
    setMeta('meta[property="og:site_name"]', "content", "VIP Groups India");
    setMeta('meta[name="twitter:card"]', "content", "summary_large_image");
    setMeta('meta[name="twitter:title"]', "content", meta.title);
    setMeta('meta[name="twitter:description"]', "content", meta.description);
    setMeta('meta[name="twitter:image"]', "content", imageUrl);
    setCanonical(canonical);
    setStructuredData(meta, canonical, imageUrl);
  }, [location.pathname]);

  return null;
}

export default SEO;
